"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _material = require("@mui/material");
var _LocalPhone = _interopRequireDefault(require("@mui/icons-material/LocalPhone"));
var _Email = _interopRequireDefault(require("@mui/icons-material/Email"));
var _styles = require("@mui/material/styles");
var _styles2 = require("../../styles");
var _types = require("../../types");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getIconStyles = function getIconStyles() {
  return {
    color: "white",
    backgroundColor: "rgb(42, 210, 201)",
    borderRadius: "8px",
    fontSize: "2rem",
    padding: "0.5rem",
    marginRight: "0.7rem"
  };
};
var StyledPhoneIcon = (0, _styles.styled)(_LocalPhone["default"])(function () {
  return getIconStyles();
});
var StyledEmailIcon = (0, _styles.styled)(_Email["default"])(function () {
  return getIconStyles();
});
var Card = function Card(_ref) {
  var label = _ref.label,
    value = _ref.value,
    Icon = _ref.icon;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Card, {
    elevation: 0,
    sx: {
      color: "white",
      backgroundColor: "rgba(255,255,255,.1)",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 2
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: {
        padding: 1
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        sx: {
          fontSize: "2rem"
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
      spacing: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "caption",
        component: "div",
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "h3",
        component: "div",
        children: value
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Typography, {
        variant: "body2",
        component: "div",
        children: ["Monday - Friday, 8:30am - 5:30pm", /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          variant: "body2",
          component: "div",
          children: "(excl bank holidays)"
        })]
      })]
    })]
  });
};
var ProblemSigningIn = function ProblemSigningIn(_ref2) {
  var setAuthMode = _ref2.setAuthMode,
    versionNumber = _ref2.versionNumber;
  var classes = (0, _styles2.useStyles)();
  var handleSetAuthMode = (0, _react.useCallback)(function (authMode) {
    setAuthMode(authMode);
  }, [setAuthMode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
      spacing: 3,
      sx: {
        padding: 2,
        marginBottom: 2
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Card, {
        label: "Phone",
        value: "0808 168 0160",
        icon: StyledPhoneIcon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Card, {
        label: "Email Address",
        value: "s12solutions-support@vitalhub.com",
        icon: StyledEmailIcon
      }), versionNumber && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Typography, {
        variant: "body2",
        component: "div",
        align: "center",
        color: "white",
        children: ["Website Version: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "fw900",
          children: versionNumber
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      variant: "text",
      onClick: function onClick() {
        return handleSetAuthMode(_types.AuthModeType.SIGN_IN);
      },
      className: (0, _clsx["default"])(classes.textWhite, "fw600"),
      children: "Go Back"
    })]
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(ProblemSigningIn);